import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const DoubleCheck = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="double-check">
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.3051 7.69093C14.6967 8.08035 14.6985 8.71351 14.3091 9.10513L7.14958 16.3051C6.96188 16.4939 6.70668 16.6 6.44048 16.6C6.17429 16.6 5.91908 16.4939 5.73139 16.3051L3.2909 13.8509C2.90148 13.4592 2.90327 12.8261 3.29489 12.4366C3.68651 12.0472 4.31968 12.049 4.7091 12.4406L6.44048 14.1818L12.8909 7.69491C13.2803 7.30329 13.9135 7.30151 14.3051 7.69093Z"
                        className="fill-current"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.3051 7.69093C20.6967 8.08035 20.6985 8.71351 20.3091 9.10513L13.1496 16.3051C12.9619 16.4939 12.7067 16.6 12.4405 16.6C12.1743 16.6 11.9191 16.4939 11.7314 16.3051L10.3818 14.9102C10.3818 14.9102 10.9084 14.3894 11.3 14C11.6916 13.6106 11.8 13.5 11.8 13.5L12.4405 14.1818L18.8909 7.69491C19.2803 7.30329 19.9135 7.30151 20.3051 7.69093Z"
                        className="fill-current"
                    />
                </g>
            </g>
        </SvgIcon>
    );
};
